import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { MerchandWhitelist } from '../settings/interfaces/MerchandWhitelist';


@Injectable({
  providedIn: 'root'
})
export class MerchandWhitelistService {


  constructor(private http: HttpClient) {}

  getAll(): Observable<MerchandWhitelist[]> {
    return this.http.get<MerchandWhitelist[]>(environment.api.urlCoreAdmin);
  }

  getById(id: number): Observable<{ data: MerchandWhitelist[] }> {
    return this.http.get<{ data: MerchandWhitelist[] }>(`${environment.api.urlCoreAdmin}/merchand-whitelist/merchant/${id}`);
  }

  create(data: MerchandWhitelist): Observable<MerchandWhitelist> {
    return this.http.post<MerchandWhitelist>(`${environment.api.urlCoreAdmin}/merchand-whitelist`, data).pipe(
      map((res: any) => res)
    );
  }

  update(id: number, data: Partial<MerchandWhitelist>): Observable<MerchandWhitelist> {
    return this.http.put<MerchandWhitelist>(`${environment.api.urlCoreAdmin}/merchand-whitelist/${id}`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.api.urlCoreAdmin}/merchand-whitelist/${id}`);
  }

  getMerchantDetail(merchantCode: string): Observable<any> {
      const url = `${environment.api.urlMerchant}`;
      const params = new HttpParams().set('merchantCode', merchantCode);
      return this.http.get<any>(url, { params });
  }
}
